import React from "react";
import styles from "./About.module.css";
import { Link } from "react-router-dom";
import img1 from "../assets/img1.jpeg";
import img2 from "../assets/img2.jpeg";

const About = () => {
  return (
  <>
  <helmet>
        <title>About Us - Saraswati Vidya Mandir</title>
        <meta name="description" content="Learn about Saraswati Vidya Mandir, our mission, vision, and the facilities we offer to nurture young minds." />
  </helmet>
      <div className={styles.aboutPage}>

      {/* HERO */}
      <section className={styles.hero}>
        <h1>About Saraswati Vidya Mandir</h1>
        <p>Building Bright Futures with Knowledge & Values</p>
      </section>

      {/* ABOUT INTRO */}
     {/* 📘 ABOUT INTRO */}
<section className={styles.aboutSection}>
  <div className={styles.aboutContainer}>

    {/* IMAGE */}
    <div className={styles.aboutImage}>
      <img src={img1} alt="School" />
    </div>

    {/* TEXT */}
    <div className={styles.aboutText}>
      <h2>Who We Are</h2>

      <p>
        Saraswati Vidya Mandir is a premier educational institution committed
        to nurturing young minds through a perfect blend of academic excellence,
        discipline, and moral values. We focus on holistic development and
        empower students to achieve their highest potential.
      </p>

      <ul>
        <li> Highly Qualified Faculty</li>
        <li> Smart Classrooms</li>
        <li> Advanced Labs</li>
        <li> Safe Campus</li>
        <li> Value-Based Education</li>
      </ul>
    </div>

  </div>
</section>




     {/* MISSION & VISION */}
<section className={styles.missionVision}>

  <div className={styles.card}>
    <div className={styles.icon}>🎯</div>
    <h3>Our Mission</h3>
    <p>
      To provide quality education that fosters academic excellence,
      creativity, and strong ethical values.
    </p>
  </div>

  <div className={styles.card}>
    <div className={styles.icon}>🌟</div>
    <h3>Our Vision</h3>
    <p>
      To create future leaders who contribute positively to society
      with knowledge, discipline, and integrity.
    </p>
  </div>

</section>


     
     {/* 🏫 FACILITIES */}
<section className={styles.facilities}>
  <h2 className={styles.heading}>Our Facilities</h2>

  <div className={styles.facilityGrid}>

    <div className={styles.facilityCard}>
      <div className={styles.icon}>🏫</div>
      <h4>Smart Classrooms</h4>
      <p>Interactive digital learning environment.</p>
    </div>

    <div className={styles.facilityCard}>
      <div className={styles.icon}>🔬</div>
      <h4>Science Labs</h4>
      <p>Fully equipped labs for experiments.</p>
    </div>

    <div className={styles.facilityCard}>
      <div className={styles.icon}>📚</div>
      <h4>Library</h4>
      <p>Rich collection of books & journals.</p>
    </div>

    <div className={styles.facilityCard}>
      <div className={styles.icon}>⚽</div>
      <h4>Sports Ground</h4>
      <p>Indoor & outdoor sports facilities.</p>
    </div>

    <div className={styles.facilityCard}>
      <div className={styles.icon}>🚌</div>
      <h4>Transport</h4>
      <p>Safe & reliable transportation system.</p>
    </div>

    <div className={styles.facilityCard}>
      <div className={styles.icon}>💻</div>
      <h4>Computer Lab</h4>
      <p>Advanced systems for digital skills.</p>
    </div>

    <div className={styles.facilityCard}>
      <div className={styles.icon}>🍽️</div>
      <h4>Mess</h4>
      <p>Hygienic & nutritious meals.</p>
    </div>

    <div className={styles.facilityCard}>
      <div className={styles.icon}>🩺</div>
      <h4>Medical Room</h4>
      <p>First aid & health care facilities.</p>
    </div>

  </div>
</section>

      {/* GALLERY PREVIEW */}
      <section className={styles.gallery}>
        <h2>Campus Life</h2>

        <div className={styles.galleryGrid}>
          <img src={img1} alt="" />
          <img src={img2} alt="" />
          <img src={img1} alt="" />
          <img src={img2} alt="" />
        </div>
      </section>



{/* 🚀 PREMIUM CTA */}
<section className={styles.ctaSection}>
  <div className={styles.overlay}></div>

  <div className={styles.ctaContent}>
    <h2>Shape Your Child’s Bright Future Today</h2>

    <p>
      Join Saraswati Vidya Mandir and give your child the perfect blend of
      knowledge, discipline, and values.
    </p>

    <div className={styles.ctaBtns}>
        <Link to="/contact">
             <button className={styles.primaryBtn}>Apply Now</button>
          </Link>
    
      <button className={styles.secondaryBtn}>Explore More</button>
    </div>
  </div>
</section>




    </div>
    </>
  );
};

export default About;